export enum RoutePath {
  Not_Found = '/404',
  Activity = '/Activity',
  OrderStatus = '/OrderStatus',
  RRIF = '/RRIF',
  RRIF_Edit = '/RRIF/Edit',
  RRIF_Edit_1 = '/RRIF/Edit/1',
  RRIF_Edit_2 = '/RRIF/Edit/2',
  RRIF_Edit_3_Success = '/RRIF/Edit/3/Success',
  RRIF_Edit_3_Error = '/RRIF/Edit/3/Error',
  Profile = '/Profile',
  Trade_MF = '/Trade/MF',
  Trade_MF_1 = '/Trade/MF/1',
  Trade_MF_1_Switch = '/Trade/MF/1/Switch',
  Trade_MF_2 = '/Trade/MF/2',
  Trade_MF_2_Switch = '/Trade/MF/2/Switch',
  Trade_MF_3_Success = '/Trade/MF/3/Success',
  Trade_MF_3_Error = '/Trade/MF/3/Error',
  Trade_Search = "/Trade/Search",
  Trade_EQ = '/Trade/EQ',
  Trade_EQ_1 = '/Trade/EQ/1',
  // Trade_EQ_2 = '/Trade/EQ/2',
  Trade_EQ_1_Modify = '/Trade/EQ/1/Modify',
  Trade_EQ_2 = '/Trade/EQ/2',
  Trade_EQ_2_Cancel = '/Trade/EQ/2/Cancel',
  Trade_EQ_2_Modify = '/Trade/EQ/2/Modify',
  Trade_EQ_3_Success = '/Trade/EQ/3/Success',
  Trade_EQ_3_Success_Cancel = '/Trade/EQ/3/Success/Cancel',
  Trade_EQ_3_Success_Modify = '/Trade/EQ/3/Success/Modify',
  Trade_EQ_3_Error = '/Trade/EQ/3/Error',
  Trade_EQ_3_Error_Cancel = '/Trade/EQ/3/Error/Cancel',
  Trade_EQ_3_Error_Modify = '/Trade/EQ/3/Error/Modify',
  CashToMargin = '/CashToMargin',
  OptionsTrading = '/OptionsTrading',
  IncomeProjection = '/IncomeProjection',
  TradingAuthorization = '/TradingAuthorization',
  ThirdPartyDetermination = '/ThirdPartyDetermination',
  TASupplemental = '/TASupplemental',
  UpdateClientInfo = '/UpdateClientInfo',
  Trade_OP = '/Trade/OP',
  Trade_OP_1 = '/Trade/OP/1',
  Onboarding = '/Onboarding',
  Onboarding_Welcome = '/Onboarding/Welcome',
  Onboarding_ExchangeAgreements = '/Onboarding/ExchangeAgreements',
  Onboarding_Education = '/Onboarding/Education',
  Onboarding_CEG = '/Onboarding/Forms/CEG',
  Onboarding_HK = '/Onboarding/Forms/HK',
  Onboarding_OPRA = '/Onboarding/Forms/OPRA',
  Onboarding_NYSE = '/Onboarding/Forms/NYSE',
  Onboarding_NASDAQ = '/Onboarding/Forms/NASDAQ',
  ExchangeAgreements = '/ExchangeAgreements',
  Agreement_CEG = '/Forms/CEG',
  Agreement_HK = '/Forms/HK',
  Agreement_OPRA = '/Forms/OPRA',
  Agreement_NYSE = '/Forms/NYSE',
  Agreement_NASDAQ = '/Forms/NASDAQ',
  Education = '/Education',
  Repapering = '/Repapering',
  Repapering_Review = '/Repapering/Review',
  Repapering_Review_Profile = '/Repapering/Review/Profile',
  Repapering_Review_Accounts = '/Repapering/Review/Accounts',
  Repapering_Review_Accounts_Edit = '/Repapering/Review/Accounts/Edit',
  Repapering_Review_Confirm = '/Repapering/Review/Confirm',
  Repapering_Review_Download = '/Repapering/Review/Download',
};

export enum TourRoutePath {
  Tours = '/Tours',
  Tours_Featured = '/Tours/Featured',
  Tours_Trade = '/Tours/Trade',
  Tours_TradeHK = '/Tours/TradeHK',
  Tours_AccountManagement = '/Tours/AccountManagement',
  Tours_InvestingPreferences = '/Tours/InvestingPreferences',
  Tours_Research = '/Tours/Research',
  Tours_IncomeProjection = '/Tours/IncomeProjection',
}

export const tourRouteNames: { [key in TourRoutePath]: string } = {
  [TourRoutePath.Tours]: 'Tours',
  [TourRoutePath.Tours_Featured]: 'Tour - Featured',
  [TourRoutePath.Tours_Trade]: 'Tour - Trade',
  [TourRoutePath.Tours_TradeHK]: 'Tour - Hong Kong Trade',
  [TourRoutePath.Tours_AccountManagement]: 'Tour - Account Management',
  [TourRoutePath.Tours_InvestingPreferences]: 'Tour - Investing Preferences',
  [TourRoutePath.Tours_Research]: 'Tour - Research',
  [TourRoutePath.Tours_IncomeProjection]: 'Tour - Income Projection',
}

export const routeNames: { [key in RoutePath | TourRoutePath]: string } = {
  [RoutePath.Not_Found]: '404 Not Found',
  [RoutePath.Activity]: 'Activity',
  [RoutePath.OrderStatus]: 'Order Status',
  [RoutePath.RRIF]: 'RRIF Details',
  [RoutePath.RRIF_Edit]: null,
  [RoutePath.RRIF_Edit_1]: 'RRIF Edit Step 1',
  [RoutePath.RRIF_Edit_2]: 'RRIF Edit Step 2',
  [RoutePath.RRIF_Edit_3_Success]: 'RRIF Edit Step 3 Success',
  [RoutePath.RRIF_Edit_3_Error]: 'RRIF Edit Step 3 Error',
  [RoutePath.Profile]: 'Profile Settings',
  [RoutePath.Trade_MF]: null,
  [RoutePath.Trade_MF_1]: 'Trade - Mutual Funds Step 1',
  [RoutePath.Trade_MF_1_Switch]: 'Trade - Mutual Fund Switch Step 1',
  [RoutePath.Trade_MF_2]: 'Trade - Mutual Funds Step 2',
  [RoutePath.Trade_MF_2_Switch]: 'Trade - Mutual Fund Switch Step 2',
  [RoutePath.Trade_MF_3_Success]: 'Trade - Mutual Funds Step 3 Success',
  [RoutePath.Trade_MF_3_Error]: 'Trade - Mutual Funds Step 3 Error',
  [RoutePath.Trade_Search]: 'Trade - Search',
  [RoutePath.Trade_EQ]: null,
  // [RoutePath.Trade_EQ_1]: 'Trade - Equity Search',
  [RoutePath.Trade_EQ_1]: 'Trade - Equity Form',
  [RoutePath.Trade_EQ_1_Modify]: 'Trade - Modify Order Form',
  [RoutePath.Trade_EQ_2]: 'Trade - Equity Review',
  [RoutePath.Trade_EQ_2_Cancel]: 'Trade - Cancel Order',
  [RoutePath.Trade_EQ_2_Modify]: 'Trade - Modify Order Review',
  [RoutePath.Trade_EQ_3_Success]: 'Trade - Equity Success',
  [RoutePath.Trade_EQ_3_Success_Cancel]: 'Trade - Cancel Order Success',
  [RoutePath.Trade_EQ_3_Success_Modify]: 'Trade - Modify Order Success',
  [RoutePath.Trade_EQ_3_Error]: 'Trade - Equity Error',
  [RoutePath.Trade_EQ_3_Error_Cancel]: 'Trade - Cancel Order Error',
  [RoutePath.Trade_EQ_3_Error_Modify]: 'Trade - Modify Order Error',
  [RoutePath.CashToMargin]: 'Cash To Margin',
  [RoutePath.OptionsTrading]: 'Options Trading',
  [RoutePath.IncomeProjection]: 'Income Projection',
  [RoutePath.TradingAuthorization]: 'Trading Authorization',
  [RoutePath.ThirdPartyDetermination]: 'Third Party Determination',
  [RoutePath.TASupplemental]: 'Trading Authorization - Supplemental Form',
  [RoutePath.UpdateClientInfo]: 'Update/Change Client Information',
  [RoutePath.Trade_OP]: null,
  [RoutePath.Trade_OP_1]: 'Trade - Options Form',
  [RoutePath.Onboarding]: 'Onboarding',
  [RoutePath.Onboarding_Welcome]: 'Onboarding - Welcome',
  [RoutePath.Onboarding_ExchangeAgreements]: 'Onboarding - Exchange Agreements',
  [RoutePath.Onboarding_Education]: 'Onboarding - Education',
  [RoutePath.Onboarding_CEG]: 'Onboarding - CEG',
  [RoutePath.Onboarding_HK]: 'Onboarding - HK',
  [RoutePath.Onboarding_OPRA]: 'Onboarding - OPRA',
  [RoutePath.Onboarding_NYSE]: 'Onboarding - NYSE',
  [RoutePath.Onboarding_NASDAQ]: 'Onboarding - NASDAQ',
  [RoutePath.ExchangeAgreements]: 'Exchange Agreements',
  [RoutePath.Agreement_CEG]: 'CEG',
  [RoutePath.Agreement_HK]: 'HK',
  [RoutePath.Agreement_OPRA]: 'OPRA',
  [RoutePath.Agreement_NYSE]: 'NYSE',
  [RoutePath.Agreement_NASDAQ]: 'NASDAQ',
  [RoutePath.Education]: 'Education',
  [RoutePath.Repapering]: 'Repapering - Dashboard',
  [RoutePath.Repapering_Review]: null,
  [RoutePath.Repapering_Review_Profile]: 'Repapering - Review Profile',
  [RoutePath.Repapering_Review_Accounts]: 'Repapering - Review Accounts',
  [RoutePath.Repapering_Review_Accounts_Edit]: 'Repapering - Review Accounts Edit',
  [RoutePath.Repapering_Review_Confirm]: 'Repapering - Review Confirm',
  [RoutePath.Repapering_Review_Download]: 'Repapering - Review Download',
  ...tourRouteNames
};

export const responsiveRoutes: (RoutePath | TourRoutePath)[] = [
  RoutePath.Onboarding,
  RoutePath.Onboarding_Welcome,
  RoutePath.Onboarding_ExchangeAgreements,
  RoutePath.Onboarding_Education,
  RoutePath.Onboarding_CEG,
  RoutePath.Onboarding_HK,
  RoutePath.Onboarding_OPRA,
  RoutePath.Onboarding_NYSE,
  RoutePath.Onboarding_NASDAQ,
  RoutePath.ExchangeAgreements,
  RoutePath.Agreement_CEG,
  RoutePath.Agreement_HK,
  RoutePath.Agreement_OPRA,
  RoutePath.Agreement_NYSE,
  RoutePath.Agreement_NASDAQ,
  RoutePath.Education,
  RoutePath.Repapering,
  ...Object.values(TourRoutePath)
];
